import { ComponentType } from 'react';

export interface Document {
    code: string;
}

export interface DocumentType {
    document: Document;
    documentPath?: string;
}

export enum DocumentCode {
    EMPLOYEE_HANDBOOK = "EMPHB",
}

export interface NavigationItem {
    name: string;
    path?: string;
    permission?: string;
    icon?: string | ComponentType;
}

export interface EmployeeDetails {
    employeeId: string;
    [key: string]: unknown; 
}

export interface RolePermission {
    component: {
        name: string;
    };
    isView: boolean;
    isCreate: boolean;
    isEdit: boolean;
    isDelete: boolean;
}

export interface UserData {
    data: {
        role: {
            name: string;
        };
        [key: string]: unknown;
    };
    [key: string]: unknown;
}

export interface RootState {
    employee: {
        employeeDetails: EmployeeDetails;
    };
    rolePermissions: {
        rolePermissions: RolePermission[];
    };
    loginUserData: {
        userData: UserData;
    };
    employeePermissionSlice: {
        employeePermission: boolean;
    };
    toggleSideBar: {
        data: boolean;
    };
    authToken: {
        token: string;
    };
    [key: string]: unknown; 
}
